import React, { Suspense, useEffect, useRef, useState } from "react";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";

/* application level */
import AppContext from "./application/AppContext";
import ListInformationModalContext from "./contexts/Content/ListInformationModalContext";
import { AppRoutes } from "./routes/AppRoutes";
import appInit from "./application/appInit";

/* Components */
import LoadingSpinner, { SpinnerSize } from "./components/general/LoadingSpinner/LoadingSpinner";
import { ToastContainer } from "react-toastify";

/* Redux */
import { store } from "./Redux/store";

/* styles */
import "./App.scss";
import "./styles/global.scss";
import "react-toastify/dist/ReactToastify.css";
import "./fonts/NotoColorEmoji.ttf";
import "./fonts/Lato-Black.ttf";
import "./fonts/Lato-Bold.ttf";
import "./fonts/Lato-Hairline.ttf";
import "./fonts/Lato-Heavy.ttf";
import "./fonts/Lato-Light.ttf";
import "./fonts/Lato-Medium.ttf";
import "./fonts/Lato-Regular.ttf";
import "./fonts/Lato-Semibold.ttf";
import "./fonts.scss";


function App() {
  const [initLoaded, setInitLoaded] = useState<boolean>(false);
  const isMounted = useRef<boolean>(true);

  // App init
  useEffect(() => {
    (async () => {
      await appInit.setup();

      if (isMounted.current) {
        setInitLoaded(true);
      }
    })();

    return () => {
      isMounted.current = false;
    };
  }, []);

  // Wait until init loaded
  if (!initLoaded) {
    return null;
  }

  return (
    <Suspense fallback={<div className="page-loading-spinner"><LoadingSpinner spinnerSize={SpinnerSize.LARGE} /></div>}>
      <div id="react-app" className="react">
        <ToastContainer />
        <Provider store={store}>
          <HashRouter>
            <AppContext>
              <ListInformationModalContext>
                <AppRoutes/>
              </ListInformationModalContext>
            </AppContext>
          </HashRouter>
        </Provider>
      </div>
    </Suspense>
  );
}

export default App;
